import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JobseekerRecruitmentBoxComponent } from './jobseeker-recruitment-box/jobseeker-recruitment-box.component';
import { JobseekerSigninComponent } from './jobseeker-signin/jobseeker-signin.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { JobseekerRoutingModule } from './jobseeker-routing.module';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { JobseekerProfileComponent } from './jobseeker-profile/jobseeker-profile.component';
import { JobseekerProfileTileComponent } from './jobseeker-profile-tile/jobseeker-profile-tile.component';
import { ProfileSectionTileComponent } from './jobseeker-profile/profile-section-tile/profile-section-tile.component';
import { HrUiModule } from '../hr-ui/hr-ui.module';
import { MatDialogModule } from '@angular/material/dialog';
import { JobseekerPersonalInfoEditComponent } from './jobseeker-personal-info-edit/jobseeker-personal-info-edit.component';
import { MatSelectModule } from '@angular/material/select';
import { JobseekerRegistrationComponent } from './jobseeker-registration/jobseeker-registration.component';
import { JobseekerRegistrationCompleteComponent } from './jobseeker-registration-complete/jobseeker-registration-complete.component';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha-2';
//import { JobseekerEmailVerificationComponent } from './jobseeker-email-verification/jobseeker-email-verification.component';
import { JobseekerEducationEditComponent } from './jobseeker-education-edit/jobseeker-education-edit.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { JobseekerDocumentUploadComponent } from './jobseeker-document-upload/jobseeker-document-upload.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { JobseekerLanguageEditComponent } from './jobseeker-language-edit/jobseeker-language-edit.component';
import { JobseekerSettingsComponent } from './jobseeker-settings/jobseeker-settings.component';
import { JobseekerSettingsPrivacyComponent } from './jobseeker-settings-privacy/jobseeker-settings-privacy.component';
import { JobseekerShellComponent } from './jobseeker-shell/jobseeker-shell.component';
import { JobseekerWorkExperienceEditComponent } from './jobseeker-work-experience-edit/jobseeker-work-experience-edit.component';
import { JobseekerSettingsChangeEmailComponent } from './jobseeker-settings-change-email/jobseeker-settings-change-email.component';
import { JobseekerSettingsBlacklistComponent } from './jobseeker-settings-blacklist/jobseeker-settings-blacklist.component';
import { SpecializationPickerComponent } from './specialization-picker/specialization-picker.component';
import { JobseekerPasswordResetComponent } from './jobseeker-password-reset/jobseeker-password-reset.component';
// import { ImageCropperModule } from 'ngx-image-cropper';
import { JobseekerPhotoEditComponent } from './jobseeker-photo-edit/jobseeker-photo-edit.component';
import { ViewJobseekerSubscriptionComponent } from './view-jobseeker-subscription/view-jobseeker-subscription.component';
import { EditJobseekerSubscriptionComponent } from './edit-jobseeker-subscription/edit-jobseeker-subscription.component';
import { JobseekerAppliesComponent } from './jobseeker-applies/jobseeker-applies.component';
import { JobseekerAppliesVacancyComponent } from './jobseeker-applies-vacancy/jobseeker-applies-vacancy.component';
import { JobseekerAppliesCvBoxComponent } from './jobseeker-applies-cv-box/jobseeker-applies-cv-box.component';
import { JobseekerInvitesComponent } from './jobseeker-invites/jobseeker-invites.component';
import { JobseekerInviteListComponent } from './jobseeker-invite-list/jobseeker-invite-list.component';
import { JobseekerInviteDetailsComponent } from './jobseeker-invite-details/jobseeker-invite-details.component';
import { StatusMessageComponent, UiModule } from '@hrra/ui';
import { CommonComponentsModule } from '@hrra/common-components';
import { JobseekerProfileForAdminComponent } from './jobseeker-profile-for-admin/jobseeker-profile-for-admin.component';
import { JobseekerPersonalInfoEditForAdminComponent } from './jobseeker-personal-info-edit-for-admin/jobseeker-personal-info-edit-for-admin.component';
import { JobseekerPhotoEditForAdminComponent } from './jobseeker-photo-edit-for-admin/jobseeker-photo-edit-for-admin.component';
import { JobseekerWorkExperienceEditForAdminComponent } from './jobseeker-work-experience-edit-for-admin/jobseeker-work-experience-edit-for-admint.component';
import { JobseekerEducationEditForAdminComponent } from './jobseeker-education-edit-for-admin/jobseeker-education-edit-for-admin.component';
import { JobseekerLanguageEditForAdminComponent } from './jobseeker-language-edit-for-admin/jobseeker-language-edit-for-admin.component';
import { JobseekerDocumentUploadForAdminComponent } from './jobseeker-document-upload-for-admin/jobseeker-document-upload-for-admin.component';
import { IndustryPickerComponent } from './industry-picker/industry-picker.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { TabsModule } from 'primeng/tabs'
import { JobseekerLoginRegistrationDialogComponent } from './jobseeker-login-registration-dialog/jobseeker-login-registration-dialog.component';
import {MatTabsModule} from '@angular/material/tabs';
import { NgxMaterialIntlTelInputComponent } from 'ngx-material-intl-tel-input';
import { MatButtonModule } from '@angular/material/button';
import { JobseekerUnsubscribeCompleteComponent } from './jobseeker-unsubscribe-complete/jobseeker-unsubscribe-complete.component';
import { JobseekerSettingsChangePasswordComponent } from './jobseeker-settings-change-password/jobseeker-settings-change-password.component';
import { VerificationDialogComponent } from './jobseeker-update-email-dialog/jobseeker-update-email.component';
import { JobseekerSkillsEditComponent } from './jobseeker-skills-edit/jobseeker-skills-edit.component';
import { JobseekerSkillsEditForAdminComponent } from './jobseeker-skills-edit-for-admin/jobseeker-skills-edit-for-admin.component';
import { JobseekerSkillsEditFormComponent } from './jobseeker-skills-edit/skills-edit-form/jobseeker-skills-edit-form.component';


@NgModule({ declarations: [
        JobseekerRecruitmentBoxComponent,
        JobseekerSigninComponent,
        JobseekerProfileComponent,
        JobseekerProfileTileComponent,
        ProfileSectionTileComponent,
        IndustryPickerComponent,
        JobseekerPersonalInfoEditComponent,
        JobseekerRegistrationComponent,
        JobseekerRegistrationCompleteComponent,
        //JobseekerEmailVerificationComponent,
        JobseekerLanguageEditComponent,
        JobseekerEducationEditComponent,
        JobseekerSkillsEditComponent,
        JobseekerSkillsEditFormComponent,
        JobseekerDocumentUploadComponent,
        JobseekerSettingsComponent,
        JobseekerSettingsPrivacyComponent,
        JobseekerShellComponent,
        JobseekerWorkExperienceEditComponent,
        JobseekerSettingsChangePasswordComponent,
        JobseekerSettingsChangeEmailComponent,
        JobseekerSettingsBlacklistComponent,
        SpecializationPickerComponent,
        IndustryPickerComponent,
        VerificationDialogComponent,
        JobseekerPasswordResetComponent,
        JobseekerPhotoEditComponent,
        ViewJobseekerSubscriptionComponent,
        EditJobseekerSubscriptionComponent,
        JobseekerAppliesComponent,
        JobseekerAppliesVacancyComponent,
        JobseekerUnsubscribeCompleteComponent,
        JobseekerAppliesCvBoxComponent,
        JobseekerInvitesComponent,
        JobseekerInviteListComponent,
        JobseekerInviteDetailsComponent,
        JobseekerProfileForAdminComponent,
        JobseekerLoginRegistrationDialogComponent,
        JobseekerPersonalInfoEditForAdminComponent,
        JobseekerPhotoEditForAdminComponent,
        JobseekerWorkExperienceEditForAdminComponent,
        JobseekerEducationEditForAdminComponent,
        JobseekerLanguageEditForAdminComponent,
        JobseekerDocumentUploadForAdminComponent,
        JobseekerSkillsEditForAdminComponent
    ], imports: [CommonModule,
        MatCheckboxModule,
        MatRadioModule,
        MatFormFieldModule,
        MatInputModule,
        TabsModule,
        SharedModule,
        MatTabsModule,
        MatButtonModule,
        FormsModule,
        ReactiveFormsModule,
        MultiSelectModule,
        SelectModule,
        InputTextModule,
        TextareaModule,
        JobseekerRoutingModule,
        AngularSvgIconModule,
        HrUiModule,
        UiModule,
        StatusMessageComponent,
        MatDialogModule,
        MatSelectModule,
        MatTooltipModule,
        RecaptchaModule,
        RecaptchaFormsModule,
        MatAutocompleteModule,
        MatProgressBarModule,
        ImageCropperComponent,
        NgxMaterialIntlTelInputComponent,
        // ImageCropperModule,
        CommonComponentsModule], 
        providers: [
          provideHttpClient(withInterceptorsFromDi(), withFetch())
        ] 
        })
export class JobseekerModule { }
